"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const PhoneIphoneOutlined_1 = __importDefault(require("@mui/icons-material/PhoneIphoneOutlined"));
const helpers_1 = require("../../../common/helpers/helpers");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const globalVariables_1 = require("../../../common/globalVariables");
const ButtonWrapper = styled_components_1.default.div `
  width: 100%;
  text-align: center;
  padding: 0 16px;
  margin: 0 auto;

  @media (min-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_CONTENT}px) {
    padding: 0;
    width: ${globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_CONTENT}px;
  }

  button {
    width: 100%;
  }
`;
const DownloadAppButton = (props) => {
    if ((!helpers_1.Helpers.isMobile.Android() && !helpers_1.Helpers.isMobile.iOS()) ||
        (!props.appIds.android && !props.appIds.itunes)) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const showAppInStore = () => {
        if (helpers_1.Helpers.isMobile.Android()) {
            return window.open(`https://play.google.com/store/apps/details?id=${props.appIds.android}`, "_blank");
        }
        if (helpers_1.Helpers.isMobile.iOS()) {
            return window.open(`https://apps.apple.com/app/id${props.appIds.itunes}`, "_blank");
        }
        return false;
    };
    return (react_1.default.createElement(ButtonWrapper, null,
        react_1.default.createElement(material_1.Button, { onClick: showAppInStore, variant: "outlined", color: "mainAppColor", startIcon: react_1.default.createElement(PhoneIphoneOutlined_1.default, null) }, helpers_1.Helpers.isMobile.Android()
            ? i18n_js_1.default.t("get_android_app")
            : i18n_js_1.default.t("get_iphone_app"))));
};
const mapStoreToProps = (store) => ({
    appIds: store.getValue("appIds"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(DownloadAppButton);
